module.exports = __webpack_public_path__ + "static/media/poster.28835376.jpeg";